const isChordProFileName = (filename: string) => {
  return (
    filename.endsWith(".pro") ||
    filename.endsWith(".chopro") ||
    filename.endsWith(".crd") ||
    filename.endsWith(".chordpro") ||
    filename.endsWith(".cho/")
  );
};
export default isChordProFileName;
